document.addEventListener('DOMContentLoaded', function() {
  // Attach event listener to the form submission
  document.getElementById('pincode-checker').addEventListener('submit', function(event) {
    event.preventDefault(); // Prevent the form from submitting normally
    
    var pincode = document.getElementById('pincode').value; // Get the pincode entered by the user
    
    // List of available pincodes
    var availablePincodes = ['625001', '625002', '625003', '625004', '625005', '625006', '625007', '625009', '625011', '625012', '625014', '625016','625017', '625018', '625019', '625020', '625023'];
    var cumbumpincodes = ['625531', '625534'];
    var resultDiv = document.getElementById('pincode-result');
    
    if (availablePincodes.includes(pincode)) {
      resultDiv.innerHTML = 'Pincode is available for delivery!';
      resultDiv.style.color = 'green';
    } else if (cumbumpincodes.includes(pincode)) {
      resultDiv.innerHTML = "Seafood delivery is available! Chicken and Mutton are not available";
      resultDiv.style.color = 'green';}

      else {
      resultDiv.innerHTML = 'Sorry, delivery is not available for this pincode.';
      resultDiv.style.color = 'red';
    }
  });
});
